export var WorkspaceRestoreSelection;
(function (WorkspaceRestoreSelection) {
    WorkspaceRestoreSelection["WORKSPACE_RESTORE_SELECTION_DRIVE"] = "DRIVE";
    WorkspaceRestoreSelection["WORKSPACE_RESTORE_SELECTION_DRIVE_WHOLE"] = "DRIVE_WHOLE";
    WorkspaceRestoreSelection["WORKSPACE_RESTORE_SELECTION_GMAIL_MESSAGE"] = "GMAIL_MESSAGE";
    WorkspaceRestoreSelection["WORKSPACE_RESTORE_SELECTION_GMAIL_MAILBOX"] = "GMAIL_MAILBOX";
    WorkspaceRestoreSelection["WORKSPACE_RESTORE_SELECTION_GROUP"] = "GROUP";
})(WorkspaceRestoreSelection || (WorkspaceRestoreSelection = {}));
